import { render, staticRenderFns } from "./VGAPIConfigurator.vue?vue&type=template&id=6067f3b6&"
import script from "./VGAPIConfigurator.vue?vue&type=script&lang=js&"
export * from "./VGAPIConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports